import { BallPointPenAction } from "../../../actions/ballpoint_pen/ballpoint_pen_action";
import { BallPointPenJsEnv } from "../../../models/ballpoint_pen/ballpoint_pen_js_env";
import { RootContainer } from "../../../root_container";
import { BallPointPenBody } from "./ballpoint_pen_body";

export class BallPointPenContainer extends RootContainer<BallPointPenJsEnv> {
  constructor(model: BallPointPenJsEnv) {
    super();
    this.mount(BallPointPenBody, 'js-special-search-ballpoint-pen-body');

    this.update(model);

    BallPointPenAction.UPDATE_EVENT.on((model: BallPointPenJsEnv) => {
      this.update(model);
    });
  }
}